import React from 'react';
import { GraphCards } from './GraphCards';
import './Graph.css';

const DEFAULT_TWO_SLICE = [1, 1];
const DEFAULT_THREE_SLICE = [1, 1, 1];

const EMPTY_BOOK_ACTIVITY = {
  _id: '3',
  title: 'User Activity Overview',
  dataValue: [0, 0, 0],
  backgroundColor: ['#99c551', '#8a73db', '#ffbe18'],
  details: [
    { color: '#99c551', label: 'Completed', values: 0 },
    { color: '#8a73db', label: 'In Progress', values: 0 },
    { color: '#ffbe18', label: 'Not Started', values: 0 },
  ],
  footerLabel: 'Total employees: 0',
  attemptedBooks: [],
};

export const Graph = ({
  badgeStats,
  bookData,
  userStats,
  bookStats,
  isBookStatsRefreshing = false,
}) => {
  return (
    <div className="dashboard__graphs">
      {userStats && (
        <GraphCards
          item={userStats?.data}
          isUser
          _id={userStats?.data?._id}
          defaultData={DEFAULT_TWO_SLICE}
        />
      )}
      {badgeStats && (
        <GraphCards
          item={badgeStats?.data}
          _id={badgeStats?.data?._id}
          isStar
          defaultData={DEFAULT_TWO_SLICE}
        />
      )}
      <GraphCards
        isBooks
        bookData={bookData}
        item={bookStats?.data ?? EMPTY_BOOK_ACTIVITY}
        _id={bookStats?.data?._id ?? EMPTY_BOOK_ACTIVITY._id}
        defaultData={DEFAULT_THREE_SLICE}
        isRefreshing={isBookStatsRefreshing}
      />
    </div>
  );
};
